/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Filename: exec-servers-controller.js
 *
 * Created by psnyder on 3/28/17.
 */

'use strict';
	function ExecServersController (
        $interval,
        $location,
	    $scope,
        ExecServersResourceFactory,
        NavbarUtilService,
        NotificationService,
        SearchFilterService
    ) {

		var self = this;
		var execServerInterval;

		self.loadingIndicator = {
			backdrop: true,
			show: false,
			title: 'Working',
			message: 'Please wait...'
		};

		self.gridColumns = [
			{
				field: 'name',
				displayName: 'Name',
				enableSorting: false,
				cellTemplate: 'components/visual/grid/base-tooltip-template.html'
			},
			{
				field: 'host',
				displayName: 'Host',
				enableSorting: false,
				cellTemplate: 'components/visual/grid/base-tooltip-template.html'
			},
			{
				field: 'port',
				displayName: 'Port',
				enableSorting: false,
				cellTemplate: 'components/visual/grid/base-tooltip-template.html'
			},
			{
				field: 'operatingSystem',
				displayName: 'OS',
				enableSorting: false,
				cellTemplate: 'components/visual/grid/base-tooltip-template.html'
			},
			{
				field: 'enabledFlag',
				displayName: 'Enabled',
				enableSorting: false,
				cellTemplate: 'system/execServers/searchView/renderers/exec-servers-checkmark-cell-template.html'
			},
			{
				field: 'onlineFlag',
				displayName: 'Online',
				enableSorting: false,
				cellTemplate: 'components/visual/grid/radio-button-template.html'
			}
		];

		self.currentGridOptions = {
			rowSelection: true,
			enableRowHeaderSelection: false,
			enableSelectAll: false,
			enableColumnResizing: false,
			enablePaginationControls: false,
			useExternalPagination: true,
			enableColumnMenus: false,
			enableFullRowSelection: false,
			rowHeight: 26,
			multiSelect: false,
			columnDefs: self.gridColumns,
			rowTemplate: '<div ng-repeat="(colRenderIndex, col) in colContainer.renderedColumns track by col.uid" ' +
			'class="ui-grid-cell" ui-grid-cell></div>',
			onRegisterApi: function(gridApi) {
				self.gridApi = gridApi;
				self.gridApi.grid.registerRowsProcessor(self.processGridFilter, 200);
			},
		};

		var queryForGridData = function () {
			self.loadingIndicator.show = true;

			// ------------- SETUP FOR FUTURE PAGINATION ------------
			//
			// var offset = self.pagingOptions.pageSize * (self.pagingOptions.currentPage - 1);
			// var queryOpts = {
			// 	fetchOffset: offset,
			// 	fetchLimit: self.pagingOptions.pageSize
			// };
			$interval.cancel(execServerInterval);
			self.execServers = ExecServersResourceFactory.query();
			self.execServers.$promise.then(function (data) {
				self.editData = data;
				self.currentGridOptions.data = self.editData;
				self.searchText = $location.search().searchText || null;
				self.filterGrid(self.searchText);
				self.loadingIndicator.show = false;
				execServerInterval = $interval(queryForGridData, 20000);
			});
		};

		self.checkMarkCellClicked = function (row) {
			var tempObject = angular.copy(row);
			if (tempObject.operatingSystem === 'UNIX') {
				tempObject.operatingSystem = 'Linux/Unix';
			}
			ExecServersResourceFactory.update({id: row.id}, tempObject).$promise.then(function (data) {
				queryForGridData();
				// self.currentGridOptions.data = data;

				if (data.enabledFlag) {
					NotificationService.createInfoNotification('Enabling Exec Server:\n The exec will go online within 5 minutes');
				} else {
					NotificationService.createInfoNotification('Disabling Exec Server:\n The exec will go offline within 5 minutes');
				}
			});
		};

		self.filterGrid = function (searchText) {
			if (searchText !== null) {
				self.searchText = searchText.toLowerCase();
				self.gridApi.grid.refresh();
			}
		};

		self.processGridFilter = function (renderableRows) {
			renderableRows.forEach(function (row) {
				row.visible = (self.searchText === null)?
					true:
					row.entity.name.toLowerCase().indexOf(self.searchText) !== -1;
			});
			return renderableRows;
		};

		// -------- SETUP FOR FUTURE PAGINATION --------
		//
		// self.pagingOptions = PaginationService;
		// PaginationService.pageDataResource = ExecServersResourceFactory;
        //
		// var handleGridDataQuery = function (gridData, responseHeaders) {
		// 	PaginationService.parseResponseHeaders(responseHeaders());
		// 	PaginationService.pageData = gridData;
		// 	self.currentPageSize = gridData.length;
		// };

		// -------HANDLERS FOR FUTURE PAGINATION TOOLBAR IF NEEDED--------
		//
		// self.paginationPrevPageHandler = function () {
		// 	--self.pagingOptions.currentPage;
		// 	self.onPaginationChanged();
		// };
        //
		// self.paginationNextPageHandler = function () {
		// 	++self.pagingOptions.currentPage;
		// 	self.onPaginationChanged();
		// };
        //
		// self.paginationJumpToPageHandler = function () {
		// 	self.onPaginationChanged();
		// };
        //
		// self.onPaginationChanged = function () {
		// 	queryForGridData();
		// };
        //
		// $scope.$watch(function() {
		// 		return self.pagingOptions.pageSize;
		// 	},
		// 	function (newValue, oldValue) {
		// 		if (newValue !== oldValue) {
		// 			self.currentPageSize = newValue;
		// 			self.onPaginationChanged();
		// 		}
		// 	}
		// );

		NavbarUtilService.viewSearchFunction = queryForGridData;
        SearchFilterService.populateCriteriaFromLocationSearch();
		queryForGridData();

		$scope.$on('$destroy', function () {
			$interval.cancel(execServerInterval);
		});
	}

	angular.module('prism-ui.execServers').component('execServersSearchView', {
		templateUrl: 'system/execServers/searchView/exec-servers-search-template.html',
		controller: ExecServersController,
		bindings: {}
	});
